import { render, staticRenderFns } from "./withdrawals-rg-module.vue?vue&type=template&id=3ded7bee&scoped=true&"
import script from "./withdrawals-rg-module.vue?vue&type=script&lang=js&"
export * from "./withdrawals-rg-module.vue?vue&type=script&lang=js&"
import style0 from "./withdrawals-rg-module.vue?vue&type=style&index=0&id=3ded7bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded7bee",
  null
  
)

export default component.exports